/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import clsx from 'clsx';
import { Box } from '@material-ui/core';
import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import ReportProblem from '@material-ui/icons/ReportProblem';
import Loader from '../loader/Loader';
import { ValidationState } from '../../shared/enums/ValidationState';

const useStyles = makeStyles(theme => ({
  ...theme.customTheme,
  default: {
    color: theme.palette.statusChip.default.contrastText,
  },
  invalid: {
    display: 'inline-block',
    position: 'relative',
    width: '1.5rem',
    height: '1.5rem',
    right: 0,
    color: theme.palette.error.main,
    borderRadius: '50%',
    [theme.breakpoints.up('xl3')]: {
      width: '1.4rem',
      height: '1.4rem',
    },
  },
  valid: {
    display: 'inline-block',
    position: 'relative',
    width: '1.3rem',
    height: '1.3rem',
    right: 0,
    borderRadius: '50%',
    backgroundColor: theme.palette.statusChip.validBackground,
    [theme.breakpoints.up('xl3')]: {
      width: '1.4rem',
      height: '1.4rem',
    },
    '&:after': {
      content: '""',
      top: '45%',
      left: '50%',
      width: '.75rem',
      height: '.35rem',
      position: 'absolute',
      transform: 'translate(-50%, -50%) rotate(-45deg)',
      borderLeft: '0.15rem solid white',
      borderBottom: '0.15rem solid white',
    },
  },
  loader: {
    position: 'relative',
    bottom: '-0.6rem',
    right: '0.3rem',
  },
}));

export function TooltipChip({ validation, chipBadgeStyle = {} }) {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Box display="flex">
      {validation === ValidationState.VALID && (
        <span className={clsx([classes.valid, chipBadgeStyle])} role="img" aria-label={t('Validated')} />
      )}
      {validation === ValidationState.INVALID && (
        <ReportProblem className={classes.invalid} role="img" aria-label={t('validation with error')} />
      )}
      {validation === ValidationState.VALIDATING && (
        <div className={classes.loader}>
          <Loader size={30} />
        </div>
      )}
    </Box>
  );
}
